const EVENT_ACTION_BASE = 'recommended.property';
const EVENT_ACTION_CLICK_BASE = `${EVENT_ACTION_BASE}.click`;
const getEventAction = (eventaction) => ({eventaction});

const EVENT_ACTION_DESTINATION = 'destination';
const EVENT_ACTION_LINK = `${EVENT_ACTION_DESTINATION}.link`;

export const EVENT = 'generic.event';
export const EVENT_CATEGORY = {eventcategory: 'recommendation'};

export const EVENT_ACTIONS = {
    CARD_VIEW: getEventAction(`${EVENT_ACTION_BASE}.view`),
    CLICK: getEventAction(`${EVENT_ACTION_CLICK_BASE}`),
    DESTINATION_CARD_CLICK: getEventAction(`${EVENT_ACTION_LINK}.click`),
};
